import { Skeleton } from "shared/ui/skeleton";

export function ProviderButtonSkeleton() {
  return <Skeleton className="w-52 h-9.5" />;
}
